/**
 * Post-login passkey prompt: ask once to set up passkey if user has none. Skip stores in localStorage.
 */
(function () {
    if (!window.PublicKeyCredential) return;

    var SKIP_STORAGE_KEY = 'passkey_prompt_skipped';

    function base64UrlToArrayBuffer(str) {
        str = String(str).replace(/-/g, '+').replace(/_/g, '/');
        var pad = str.length % 4;
        if (pad) str += '===='.slice(0, 4 - pad);
        var binary = atob(str);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
        return bytes.buffer;
    }

    function arrayBufferToBase64Url(buffer) {
        var bytes = new Uint8Array(buffer);
        var binary = '';
        for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
        return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    function getCsrfPayload() {
        var name = document.querySelector('meta[name="csrf-token-name"]');
        var hash = document.querySelector('meta[name="csrf-token"]');
        var payload = {};
        if (name && name.content) payload[name.content] = hash && hash.content ? hash.content : '';
        return payload;
    }

    function showSuccessAndClose(modalEl) {
        var bodyEl = document.getElementById('passkey-prompt-modal-body');
        var successText = modalEl.getAttribute('data-passkey-success') || 'Passkey added.';
        if (bodyEl) bodyEl.innerHTML = '<p class="text-success mb-0">' + successText + '</p>';
        setTimeout(function () {
            if (typeof jQuery !== 'undefined' && jQuery(modalEl).modal) jQuery(modalEl).modal('hide');
        }, 1500);
    }

    function showNameStep(modalEl, credentialId) {
        var titleEl = document.getElementById('passkey-prompt-title');
        var bodyEl = document.getElementById('passkey-prompt-modal-body');
        var footerEl = modalEl.querySelector('.modal-footer');
        if (!bodyEl || !footerEl) return;
        var nameTitle = modalEl.getAttribute('data-passkey-name-title') || 'Name this passkey';
        var enterNameLabel = modalEl.getAttribute('data-passkey-enter-name') || 'Name this passkey (e.g. My laptop, YubiKey):';
        var saveLabel = modalEl.getAttribute('data-passkey-name-save') || 'Save';
        var skipLabel = modalEl.getAttribute('data-passkey-skip') || 'Skip';
        if (titleEl) titleEl.textContent = nameTitle;
        bodyEl.innerHTML = '<div class="single-input application-form-input-wrapper mb-0"><h4 class="input-title">' + enterNameLabel + '</h4><div class="common-input-styling w-100"><input type="text" id="passkey-name-input" class="w-100" maxlength="255" autocomplete="off" placeholder=""></div></div>';
        footerEl.innerHTML = '<button type="button" class="default-button default-button-small default-button-simple passkey-name-skip">' + skipLabel + '</button>' +
            '<button type="button" class="default-button default-button-small default-button-black-alternative passkey-name-save">' + saveLabel + '</button>';
        footerEl.setAttribute('data-credential-id', String(credentialId));
        var input = document.getElementById('passkey-name-input');
        if (input) {
            input.focus();
            input.addEventListener('keydown', function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    footerEl.querySelector('.passkey-name-save').click();
                }
            });
        }
    }

    function runCreationFlow(modalEl, setupBtn) {
        setupBtn.disabled = true;
        var payload = getCsrfPayload();
        fetch('/profile/auth/passkey/creation-options', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
            body: new URLSearchParams(payload)
        })
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (window.CSRFHelper && data && data.csrf_name !== undefined) window.CSRFHelper.updateCSRFMeta(data);
                if (!data.success || !data.options || !data.options.publicKey) {
                    setupBtn.disabled = false;
                    return;
                }
                var pubKey = data.options.publicKey;
                if (typeof pubKey.challenge === 'string') pubKey.challenge = base64UrlToArrayBuffer(pubKey.challenge);
                if (pubKey.user && typeof pubKey.user.id === 'string') pubKey.user.id = base64UrlToArrayBuffer(pubKey.user.id);
                if (pubKey.excludeCredentials && Array.isArray(pubKey.excludeCredentials)) {
                    pubKey.excludeCredentials = pubKey.excludeCredentials.map(function (c) {
                        return { type: c.type || 'public-key', id: typeof c.id === 'string' ? base64UrlToArrayBuffer(c.id) : c.id };
                    });
                }
                return navigator.credentials.create({ publicKey: pubKey });
            })
            .then(function (credential) {
                if (!credential) {
                    setupBtn.disabled = false;
                    return;
                }
                var verifyPayload = getCsrfPayload();
                verifyPayload.clientDataJSON = arrayBufferToBase64Url(credential.response.clientDataJSON);
                verifyPayload.attestationObject = arrayBufferToBase64Url(credential.response.attestationObject);
                if (credential.authenticatorAttachment) {
                    verifyPayload.attachment = credential.authenticatorAttachment;
                }
                return fetch('/profile/auth/passkey/verify-creation', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
                    body: new URLSearchParams(verifyPayload)
                });
            })
            .then(function (r) { return r && r.json ? r.json() : null; })
            .then(function (data) {
                setupBtn.disabled = false;
                if (data && data.success) {
                    if (window.CSRFHelper && data.csrf_name) window.CSRFHelper.updateCSRFMeta(data);
                    var credentialId = data.credential_id;
                    if (credentialId) {
                        showNameStep(modalEl, credentialId);
                    } else {
                        showSuccessAndClose(modalEl);
                    }
                }
            })
            .catch(function (err) {
                setupBtn.disabled = false;
            });
    }

    document.addEventListener('DOMContentLoaded', function () {
        var modalEl = document.getElementById('passkey-prompt-modal');
        var skipBtn = document.getElementById('passkey-prompt-skip');
        var setupBtn = document.getElementById('passkey-prompt-setup');
        if (!modalEl || !skipBtn || !setupBtn) return;
        if (localStorage.getItem(SKIP_STORAGE_KEY)) return;

        fetch('/profile/auth/passkey/status', {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (data && data.success && !data.has_passkeys) {
                    if (typeof jQuery !== 'undefined' && jQuery(modalEl).modal) {
                        jQuery(modalEl).modal('show');
                    } else {
                        modalEl.classList.add('show');
                        modalEl.style.display = 'block';
                    }
                }
            })
            .catch(function () {});

        function markSkipped() {
            try { localStorage.setItem(SKIP_STORAGE_KEY, '1'); } catch (e) {}
        }

        skipBtn.addEventListener('click', function () {
            markSkipped();
            if (typeof jQuery !== 'undefined' && jQuery(modalEl).modal) jQuery(modalEl).modal('hide');
            else {
                modalEl.classList.remove('show');
                modalEl.style.display = 'none';
            }
        });

        if (typeof jQuery !== 'undefined' && jQuery(modalEl).on) {
            jQuery(modalEl).on('hidden.bs.modal', markSkipped);
        }

        setupBtn.addEventListener('click', function () {
            runCreationFlow(modalEl, setupBtn);
        });

        modalEl.addEventListener('click', function (e) {
            var skipBtn = e.target && e.target.closest ? e.target.closest('.passkey-name-skip') : null;
            var saveBtn = e.target && e.target.closest ? e.target.closest('.passkey-name-save') : null;
            if (skipBtn) {
                showSuccessAndClose(modalEl);
                return;
            }
            if (saveBtn) {
                var footer = modalEl.querySelector('.modal-footer');
                var credentialId = footer && footer.getAttribute('data-credential-id');
                var input = document.getElementById('passkey-name-input');
                var nameToSet = input ? (input.value || '').trim().slice(0, 255) : '';
                if (saveBtn.disabled) return;
                if (!credentialId) {
                    showSuccessAndClose(modalEl);
                    return;
                }
                saveBtn.disabled = true;
                if (!nameToSet) {
                    showSuccessAndClose(modalEl);
                    return;
                }
                var payload = getCsrfPayload();
                payload.credential_id = credentialId;
                payload.name = nameToSet;
                fetch('/profile/auth/passkey/rename', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
                    body: new URLSearchParams(payload)
                })
                    .then(function (r) { return r.json(); })
                    .then(function (renameData) {
                        if (window.CSRFHelper && renameData && renameData.csrf_name) window.CSRFHelper.updateCSRFMeta(renameData);
                        showSuccessAndClose(modalEl);
                    })
                    .catch(function () {
                        saveBtn.disabled = false;
                        showSuccessAndClose(modalEl);
                    });
            }
        });
    });
})();
